import React from 'react';
import PropTypes from 'prop-types';
require('es6-promise').polyfill();
import { DoorDialog } from './styled/AdventCalendar';
import HtmlContent from './HtmlContent';

export default class CalendarFinishedPopupContainer extends React.Component {
    constructor(props) {
        super(props);

        this.handleDoorClose = this.handleDoorClose.bind(this);
    }

    handleDoorClose = () => {
        const {
            doorCloseClickAction,
        } = this.props;

        doorCloseClickAction();
    };

    render() {
        const {
            dialogShown,
            content,
        } = this.props;

        let dialogOpen = dialogShown;

        return (
            <DoorDialog
                className="adventcalendar__door-dialog"
                id={`adventcalendar-popup-dialog`}
                dialogShown={dialogOpen}
            >
                <div className="adventcalendar__door-dialog-content">
                    <div>
                        <div className="adventcount-modal">
                            <HtmlContent content={content} />
                        </div>
                    </div>
                </div>
            </DoorDialog>
        );
    }
}

CalendarFinishedPopupContainer.propTypes = {
    dialogShown: PropTypes.bool.isRequired,
    doorCloseClickAction: PropTypes.func.isRequired,
    content: PropTypes.string.isRequired,
};
